// src/components/buyer-sales-list/types.ts
import { ReactNode } from "react";
import { IOrderPlus } from "../../models/Order";

export interface IOrderFilters {
  orderStatus?: string;
  deliveryNoteStatus?: string;
  paymentStatus?: string;
  invoiceStatus?: string;
  businessId?: string;
  startDate?: string;
  endDate?: string;
  search?: string;
  paymentTermCondition?: string;
  page: number;
  limit: number;
}

export const defaultFilters: IOrderFilters = {
  orderStatus: "",
  deliveryNoteStatus: "",
  paymentStatus: "",
  invoiceStatus: "",
  businessId: "",
  startDate: "",
  endDate: "",
  search: "",
  paymentTermCondition: "",
  page: 1,
  limit: 20,
};

export interface IColumn {
  key: string;
  label: string;
  width?: number;
  minWidth?: number;
  sortable?: boolean;
  render?: (row: IOrderPlus) => ReactNode;
}

export interface IColumnGroup {
  id: string;
  label: string;
  columns: IColumn[];
  defaultExpanded: boolean;
  alwaysVisible?: boolean;
}

export interface IBulkAction {
  id: string;
  label: string;
  icon: ReactNode;
  color: string;
  allowedStatuses?: string[];
  handler: (ids: string[]) => Promise<void>;
}

export interface IOrderSelection {
  selectedIds: Set<string>;
  selectedCount: number;
  toggleSelection: (id: string) => void;
  selectAll: (ids: string[]) => void;
  clearSelection: () => void;
  isSelected: (id: string) => boolean;
}

export interface IExportOptions {
  format: "xlsx" | "csv";
  columns: "all" | "visible";
  data: "filtered" | "all";
}
